var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from "react";
export default (function (props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    className: "icon"
  }, props, {
    fill: "currentColor",
    style: {
      height: "1em"
    }
  }), React.createElement("path", {
    d: "M10 270.19V418h107.32l.41-93.75.61-93.55 93.75-.61 93.55-.41V122.36H10v147.83zM694.38 176.03v53.66h186.28V418H990V122.38H694.38v53.65zM10 729.81v147.81h295.62V770.3h-188.3V582H10v147.81zM880.66 676.16v94.15H694.38v107.32H990V582H880.66v94.16z"
  }));
});